// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingCredentials_container__3STZQ","loadingSection":"LoadingCredentials_loadingSection__icBxC","lottie":"LoadingCredentials_lottie__1M7Uc"};